<wk-settings-breadcrumb></wk-settings-breadcrumb>
<div class="wk-sm__container">
    @for (tile of tiles(); track tile.id) {
        @if (tile.visible) {
            <div (click)="onTileClick(tile)" [attr.data-tile-id]="tile.id" class="wk-sm__tile">
                <div class="wk-sm__tile-content">
                    <h5 class="wk-sm__tile-title">{{ tile.titleKey | translate }}</h5>
                    <p class="wk-sm__tile-description">{{ tile.descriptionKey | translate }}</p>
                </div>
            </div>
        }
    }
</div>
